import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../../mutation-types';
import transactionApi from '../../../../api/transaction';
import bankApi from '../../../../api/bank';

const defaultState = () => ({
    transactionDetail: {},
    konfirmResponse: {
        code: '',
        data: {
            from_bank_name: '',
            from_bank_account_name: '',
            from_bank_account_no: '',
            from_bank_branch: '',
            transfer_value: '',
            origin_date: '',
            note: '',
        }
    },
    dataBank: {}
});

const state = defaultState();

const getters = {};

const mutations = {
    listTransactionDetail12(state, data) {
        state.transactionDetail = Object.assign({}, state.transactionDetail, data);
    },
    resetKonfirmResponse(state) {
        let first = {
            code: '',
            data: {
                from_bank_name: '',
                from_bank_account_name: '',
                from_bank_account_no: '',
                from_bank_branch: '',
                transfer_value: '',
                origin_date: '',
                note: '',
            }
        }
        state.konfirmResponse = Object.assign({}, state.konfirmResponse, first);
    },
    saveConfirmResponse(state, data) {
        state.konfirmResponse = Object.assign({}, state.konfirmResponse, data);
    },
    listDataBank(state, data) {
        state.dataBank = Object.assign({}, state.dataBank, data);
    },
    reset(state) {
        Object.assign(state, defaultState());
    }
};

const actions = {
    getTransactionDetail({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.detailPublic(value).then(({ data }) => {
            commit('listTransactionDetail12', data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            commit('listTransactionDetail12', data);
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    konfirmation({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.transferPublic(value).then((res) => {
            const data = res.data;
            commit('saveConfirmResponse', data)
            let param = {
                code: state.transactionDetail.data.trx_code,
                mobilephone: state.transactionDetail.data.trx_buyer_mobilephone
            }
            dispatch('getTransactionDetail', param)
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const data = err.response.data;

            commit('saveConfirmResponse', data)
        });
    },
    Penerimaan({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.penerimaanPublic(value).then((res) => {
            const data = res.data;
            commit('saveConfirmResponse', data)
            dispatch('getTransactionDetail', { code: state.transactionDetail.data.trx_code, mobilephone: state.transactionDetail.data.trx_buyer_mobilephone })
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const data = err.response;
            commit('saveConfirmResponse', data)
        });
    },
    getDataBank({ commit, dispatch }) {
        commit(PROGRESS_START, null, { root: true });
        bankApi.bankData().then(({ data: { data: { results } } }) => {
            commit('listDataBank', results);
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    errorHandler({ commit }, response) {
        commit('failed', { type: 'error', message: response.message });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};